import { MaterializeAction } from 'angular2-materialize';
import { Component, Input, Output, EventEmitter, ViewChildren, ElementRef } from '@angular/core';
import { FormGroup, FormControlName } from '@angular/forms';
import { ILookup } from '../shared/lookup';
import { Observable } from 'rxjs/Observable';
import { GenericValidator } from '../shared/generic-validator';
import { SharedUtils } from '../shared/utils';
import { AuthService } from '../shared/core/index';
declare var Materialize: any;
@Component({
    selector: 'company-contact',
    template: require('./company-contact.component.html')
})
export class CompanyContactComponent  {

    @Input() currentItem: string;
    @Output() selectedItem = new EventEmitter<FormGroup>();
    @Input('group')
    public contactItemForm: FormGroup;
    @Input('count')
    public count: number;
    @Input('current')
    public current: number;
    @Input('lookup')
    public lookup: ILookup[];
    @Output() addItem = new EventEmitter()
    @Output() removeItem = new EventEmitter()

    displayMessage: { [key: string]: string } = {};
    private validationMessages: { [key: string]: { [key: string]: string } };
    private genericValidator: GenericValidator;
    @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
    
    constructor(private _authService: AuthService) {
        // Defines all of the validation messages for the form.
            // These could instead be retrieved from a file or database.
            this.validationMessages = {
                email: {
                    pattern: 'Please Enter a valid Email.',
                    maxlength: 'Contact Title Cannot be Longer than 255 Characters'
                },
                name: {
                    maxlength: 'Contact Name Cannot be Longer than 80 Characters'
                },
                contactTitle: {
                    maxlength: 'Contact Title Cannot be Longer than 255 Characters'
                },
                address: {
                    maxlength: 'Address Cannot be Longer than 255 Characters'
                },
                address2: {
                    maxlength: 'Address 2 Cannot be Longer than 255 Characters'
                },
                city: {
                    maxlength: 'City Cannot be Longer than 255 Characters'
                },
                state: {
                    maxlength: 'State Cannot be Longer than 255 Characters'
                },
                zipCode: {
                    maxlength: 'Zip Code Cannot be Longer than 100 Characters'
                },
                country: {
                    maxlength: 'Country Cannot be Longer than 255 Characters'
                },
                phoneNumber: {
                    maxlength: 'Phone Number Cannot be Longer than 40 Characters'
                },
                cellNumber: {
                    maxlength: 'Cell Number Cannot be Longer than 40 Characters'
                },
                faxNumber: {
                    maxlength: 'Fax Number Cannot be Longer than 40 Characters'
                },
                phoneNumber2: {
                    maxlength: 'Office Phone Number Cannot be Longer than 40 Characters'
                },
                phoneNumber3: {
                    maxlength: 'Other Phone Number Cannot be Longer than 40 Characters'
                },
                notes: {
                    maxlength: 'Notes Cannot be Longer than 255 Characters'
                }
                
          };
    
          // Define an instance of the validator for use with this form, 
          // passing in this form's set of validation messages.
          this.genericValidator = new GenericValidator(this.validationMessages);
      }

    ngAfterViewInit() {
        this.initMaterial();
        //Watch for the blur event from any input element on the form.
        let controlBlurs: Observable<any>[] = this.formInputElements
            .map((formControl: ElementRef) => Observable.fromEvent(formControl.nativeElement, 'blur'));
        
        //Merge the blur event observable with the valueChanges observable
        Observable.merge(this.contactItemForm.valueChanges, ...controlBlurs)
        .debounceTime(500)
        .subscribe(value => {
            this.displayMessage = this.genericValidator.processMessages(this.contactItemForm);
        });
        $('.tooltipped').tooltip({ delay: 50 });
        SharedUtils.RemoveTooltipIfNeeded();
    }
    isDefaultContact(){
        var retValue = this.currentItem == this.contactItemForm.controls.id.value;
        return retValue;
    }
    addContactItem() {
        this.addItem.next();
        return false;
    }

    removeContactItem() {
        this.removeItem.next();
        return false;
    }
    
    onItemSelectionChange(event) {
        console.log('entry: ' + JSON.stringify(event.value))  ;
        this.selectedItem.next(event);
        return false;
    }
    initMaterial() {
        Materialize.updateTextFields();
       
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/address-book/company-contact.component.ts